import common from './common'
import system from './system'
import project from './project'
import iot from './iot'
import device from './device'
import workPlan from './workPlan'
import patrol from './patrol'
import machine from './machine'
import material from './material'
import statement from './statement'
import file from './file'
import irrigation from './irrigation'
import moving from './moving'
import person from './person'
import overview from './overview'
import operationmanage from './operationmanage'
import maintenanceDaily from './maintenanceDaily'
import workOrder from './workOrder'
import projectFile from './projectFile'
import worker from './worker'
import laborManage from './laborManage'
import measure from './measure'
import seedling from './seedling'
import process from './process'
import operate from './operate'
import assessmentScore from './assessmentScore'
import tourist from './tourist'

export default {
  common,
  system,
  project,
  iot,
  device,
  workPlan,
  patrol,
  statement,
  file,
  machine,
  material,
  irrigation,
  moving,
  person,
  overview,
  operationmanage,
  maintenanceDaily,
  workOrder,
  projectFile,
  worker,
  laborManage,
  measure,
  seedling,
  process,
  operate,
  assessmentScore,
  tourist
}
